import React, { useMemo } from 'react'

import i18n from 'i18n-literally'
import { partition } from 'ramda'

import { TextField } from '@mui/material'

import { useFormikContext } from 'formik'

import VirtualizedAutocomplete from '~/src/UI/Shared/VirtualizedAutocomplete'

import { getAllCountriesTimezones, normalizeTimezones } from './utils'

const TimezoneAutocomplete = ({
  disabled = false,
  inputValue,
  setInputValue,
}) => {
  const allTimezones = useMemo(() => getAllCountriesTimezones(), [])
  const { setFieldValue } = useFormikContext()
  return (
    <VirtualizedAutocomplete
      filterOptions={(opts, { inputValue: input }) => {
        if (input == null) return opts
        const inputPattern = new RegExp(input.replace(/[^a-zA-Z]+/g, '.*'), 'i')
        return partition(opt => opt.value.match(inputPattern), opts).flat()
      }}
      disabled={disabled}
      value={inputValue}
      onChange={(event, selectedOption) => {
        setInputValue(selectedOption?.label)
        setFieldValue('timezone', selectedOption?.value)
      }}
      options={allTimezones}
      isOptionEqualToValue={(opt, value) => opt.label.includes(value)}
      inputValue={inputValue}
      onInputChange={(event, newInput) => {
        setInputValue(normalizeTimezones(newInput))
      }}
      sx={{
        '& [class*=MuiFilledInput-input]': {
          position: 'relative'
        }
      }}
      renderInput={params => <TextField {...params} required label={i18n`Timezone`} />}
    />
  )
}

export default TimezoneAutocomplete
